module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// /home/g0/live-stream/web-client/node_modules/core-js/modules/_function-to-string.js
// module id = eL2l
// module chunks = 5 6 7 8